module.exports = __webpack_public_path__ + "static/media/jenny.afff988c.jpg";